import React, { Component } from "react";
import { withRouter } from "./withRouter";
import mapboxgl from "mapbox-gl";
import { tableFromIPC } from "apache-arrow";
import { Box , Typography, MenuItem, Stack, TextField} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
export function baseColorForLikertKey(group, key) {
  const pol = group.polarity || {};
  // Find which polarity (pos/neg/neu) corresponds to this key
  const tag = Object.entries(pol).find(([polarity, polKey]) => polKey === key)?.[0];

  
  if (tag === "pos") return "#2E7D32";
  if (tag === "neg") return "#C62828";
  return "#6e6e6e";
}
const rowsFromTable = (table) => {
  const cols = table.schema.fields.map(f => f.name);
  const rows = [];
  for (let i = 0; i < table.numRows; i++) {
    const obj = {};
    for (const c of cols) obj[c] = table.getChild(c).get(i);
    rows.push(obj);
  }
  return rows;
};

const possibleAreas = [
  { area_name: "All", area_id: null },
  { area_name: "Auckland Central", area_id: 1 },
  { area_name: "Banks Peninsula", area_id: 2 },
  { area_name: "Botany", area_id: 3 },
  { area_name: "Christchurch Central", area_id: 4 },
  { area_name: "Christchurch East", area_id: 5 },
  { area_name: "Coromandel", area_id: 6 },
  { area_name: "Dunedin", area_id: 7 },
  { area_name: "East Cape", area_id: 8 },
  { area_name: "East Coast Bays", area_id: 9 },
  { area_name: "Epsom", area_id: 10 },
  { area_name: "Glendene", area_id: 11 },
  { area_name: "Hamilton East", area_id: 12 },
  { area_name: "Hamilton West", area_id: 13 },
  { area_name: "Henderson", area_id: 14 },
  { area_name: "Hutt South", area_id: 15 },
  { area_name: "Ilam", area_id: 16 },
  { area_name: "Invercargill", area_id: 17 },
  { area_name: "Kaikōura", area_id: 18 },
  { area_name: "Kaipara ki Mahurangi", area_id: 19 },
  { area_name: "Kapiti", area_id: 20 },
  { area_name: "Kenepuru", area_id: 21 },
  { area_name: "Māngere", area_id: 22 },
  { area_name: "Manurewa", area_id: 23 },
  { area_name: "Maungakiekie", area_id: 24 },
  { area_name: "Mt Albert", area_id: 25 },
  { area_name: "Mt Maunganui", area_id: 26 },
  { area_name: "Mt Roskill", area_id: 27 },
  { area_name: "Napier", area_id: 28 },
  { area_name: "Nelson", area_id: 29 },
  { area_name: "New Plymouth", area_id: 30 },
  { area_name: "North Shore", area_id: 31 },
  { area_name: "Northcote", area_id: 32 },
  { area_name: "Northland", area_id: 33 },
  { area_name: "Ōtāhuhu", area_id: 34 },
  { area_name: "Pakuranga", area_id: 35 },
  { area_name: "Palmerston North", area_id: 36 },
  { area_name: "Papakura", area_id: 37 },
  { area_name: "Port Waikato", area_id: 38 },
  { area_name: "Rangitata", area_id: 39 },
  { area_name: "Rangitīkei", area_id: 40 },
  { area_name: "Remutaka", area_id: 41 },
  { area_name: "Rotorua", area_id: 42 },
  { area_name: "Selwyn", area_id: 43 },
  { area_name: "Southland", area_id: 44 },
  { area_name: "Taieri", area_id: 45 },
  { area_name: "Takanini", area_id: 46 },
  { area_name: "Tāmaki", area_id: 47 },
  { area_name: "Taranaki-King Country", area_id: 48 },
  { area_name: "Taupō", area_id: 49 },
  { area_name: "Tauranga", area_id: 50 },
  { area_name: "Tukituki", area_id: 51 },
  { area_name: "Upper Harbour", area_id: 52 },
  { area_name: "Waikato", area_id: 53 },
  { area_name: "Waimakariri", area_id: 54 },
  { area_name: "Wairarapa", area_id: 55 },
  { area_name: "Waitākere", area_id: 56 },
  { area_name: "Waitaki", area_id: 57 },
  { area_name: "Wellington Bays", area_id: 58 },
  { area_name: "Wellington North", area_id: 59 },
  { area_name: "West Coast-Tasman", area_id: 60 },
  { area_name: "Whanganui", area_id: 61 },
  { area_name: "Whangaparāoa", area_id: 62 },
  { area_name: "Whangārei", area_id: 63 },
  { area_name: "Wigram", area_id: 64 }
];
// Define party full names and official colours
const PARTY_INFO = {
    nat_pred_n: { name: "National", color: "#0056A8" },
    act_pred_n: { name: "ACT", color: "#FFD700" },
    nzf_pred_n: { name: "NZF", color: "#000000" },
    lab_pred_n: { name: "Labour", color: "#E82C2C" },
    green_pred_n: { name: "Green", color: "#009639" },
    tpm_pred_n: { name: "TPM", color: "#CC0033" },
    oth_pred_n: { name: "Other", color: "#999999" }
};

const issueData = {
  econ_issue_n: { label: "Economy" },
  health_issue_n: { label: "Health" },
 education_issue_issue_n: { label: "Education" },
  crime_issue_n: {  label: "Crime" },
  housing_issue_n: { label: "Housing" },
  inflation_issue_n: {  label: "Inflation" },
  climate_issue_n: { label: "Climate" },
  poverty_issue_n: { label: "Poverty" },
  immigration_issue_n: {  label: "Immigration" },
  transport_issue_n: {  label: "Transport" },
  defence_issue_n: {  label: "Defence" },
  drugs_issue_n: {  label: "Drugs" },
 maori_issue_n: {  label: "Māori Issues" },
  pollution_issue_n: {  label: "Pollution" },
  race_rel_issue_n: {  label: "Race Relations" },
  unemployment_issue_n: {  label: "Unemployment" },
  tax_issue_n: {  label: "Tax" }
}

// Build labels and colors in one go
const buildLabelsAndColors = () => {
  const labels = {};
  const colors = {};

  Object.entries(PARTY_INFO).forEach(([key, info]) => {
    labels[key] = info.name;
    colors[key] = info.color;
  });

  return { labels, colors };
};




class NZ2026Summary extends Component {
      constructor(props) {
    super(props);
    this.state = {
      geoLevel: "constituency",
      metricRows: null, 
      loading: false,
      hoverInfo: null,
      hoverAreaId: null,
      selectedStateBounds: null,
      selectedFeature: null,   
      geoData:props.constituencyMap,
      styleLoaded: false,
      viewState: null,
      metricRowsConst: null,
      metricRowsNational:null,
            chosenGender:null,
      chosenAge:null,
      chosenEthnicity:null,
      chosenEducation:null,
      chosenPV:null,
      chosenElectorate:null
    };
    
    this.mapRef = React.createRef();
    this._inflight = null; 
    this._lastKey = null;
    this._lastAt = 0;

    
  }

  
  componentDidMount() {
  const run = async () => {
    await this.fetchMetrics("national", null, true);
    await this.fetchMetrics("constituency", null, true);
  };
  run();
}

   componentDidUpdate(prevProps, prevState) {
       const chosenGenderChanged      = prevState.chosenGender !== this.state.chosenGender;
    const chosenAgeChanged      = prevState.chosenAge !== this.state.chosenAge;
    const chosenEthnicityChanged      = prevState.chosenEthnicity !== this.state.chosenEthnicity;
    const chosenEducationChanged = prevState.chosenEducation !== this.state.chosenEducation;
    const chosenPVChanged      = prevState.chosenPV !== this.state.chosenPV;
    const chosenElectorateChanged      = prevState.chosenElectorate !== this.state.chosenElectorate;
     const filtersChanged = chosenGenderChanged || chosenAgeChanged || chosenEthnicityChanged ||chosenPVChanged || chosenElectorateChanged || chosenEducationChanged



  
    const needRefetch = filtersChanged ;
    if (needRefetch) {
    this.fetchMetrics("national", null, true);
      this.fetchMetrics(this.state.geoLevel, this.state.selectedFeature?.area_id);
    }

   
    
  }
  _inflightBaseline = null;
  _lastBaselineKey = null;
  _lastBaselineAt = 0;
    requestKey = (level) => {

    return `${level}`;
  };


  //main function that grabs data
    fetchMetrics = async (level, constCode, save_const_results) => {
  const controller = new AbortController(); // new controller for this call
  const signal = controller.signal;

  const reqKey = this.requestKey(level);
  const now = Date.now();
  if (this._lastKey === reqKey && now - this._lastAt < 700) return;
  this._lastKey = reqKey;
  this._lastAt = now;


    let keysBody 
          keysBody= [
                    "nat_pred_n",
                    "lab_pred_n",
                    "act_pred_n",
                    "nzf_pred_n",
                    "green_pred_n",
                    "tpm_pred_n",
                    "oth_pred_n",
                    "inflation_issue_n",
                    "health_issue_n",
                    "econ_issue_n",
                    "crime_issue_n",
                    "housing_issue_n",
                    "poverty_issue_n",
                    "unemployment_issue_n",
                    "climate_issue_n",
                    "education_issue_issue_n",
                    "transport_issue_n",
                    "drugs_issue_n",
                    "race_rel_issue_n",
                    "tax_issue_n",
                    "pollution_issue_n",
                    "maori_issue_n",
                    "immigration_issue_n",
                    "defence_issue_n",
                    "gov_good_n",
                    "gov_bad_n",
                    "gov_dn_n",
                    "coalition_consider", 
                    "nat_consider", 
                    "act_consider", 
                    "nzf_consider", 
                    "lab_consider", 
                    "green_consider", 
                    "tpm_consider", 
                    "turnout_1_p"
                  ]  

                
    let turnout_weight
    turnout_weight = "turnout_1_n"
    const body = {
      groupKeys: keysBody,
      filters:{
      gender: this.state.chosenGender ?? null,     
      age: this.state.chosenAge ?? null,            
      ethnicity: this.state.chosenEthnicity ?? null,
      education: this.state.chosenEducation ?? null,
      vote_2023: this.state.chosenPV ?? null,     
    },
      constCode: constCode,
    turnout_weight: turnout_weight

    };
  
    this.setState({ loading: true });
  

 
    try {
      // --- call main metrics endpoint ---
          const resMain = await fetch(`/api/${level}_data_arrow/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
                signal,
                });
      if (!resMain.ok) throw new Error(`metrics fetch ${resMain.status}`);
      const bufMain = await resMain.arrayBuffer();
      const tableMain = tableFromIPC(bufMain);
      const rowsMain = rowsFromTable(tableMain);
      // --- update state with both ---
      if(save_const_results){
        if(level==="national"){
          this.setState(
             { metricRowsNational: rowsMain })
            }else{
            this.setState(
            { metricRowsConst: rowsMain ,
                metricRows: rowsMain,})
            }
      }else{
           this.setState({
        metricRows: rowsMain,
        loading: false,
        
      });
      }
   
    } catch (e) {
      if (e.name !== "AbortError") console.error("metrics error:", e);
      this.setState({ metricRows: null,  loading: false });
    } finally {
      this._inflight = null;
    }

  }

       handlechosenGenderChange     = (val) => this.setState({ chosenGender: val });
 handlechosenAgeChange     = (val) => this.setState({ chosenAge: val });
 handlechosenEthnicityChange     = (val) => this.setState({ chosenEthnicity: val });
 
 handlechosenEducationChange     = (val) => this.setState({ chosenEducation: val });
 handlechosenPVChange     = (val) => this.setState({ chosenPV: val });
 handlechosenElectorateChange     = (val) => {this.setState({ chosenElectorate: val })};
   


  render() {
 const constrows = this.state?.metricRows || [];
 const natrows = this.state?.metricRowsNational || [];
const rows = [
  ...(this.state?.metricRows || []),
  ...(this.state?.metricRowsNational || []),
];


 const percentFormatter = (params) => {

      const value = Number(params);
      if (value == null || isNaN(value)) return ""; // Handle missing values
      return `${value.toFixed(2)}%`;
    };

    // Identify all columns ending with "_issue_n"
    const issueKeys =
      rows.length > 0
        ? Object.keys(rows[0]).filter((key) => key.endsWith("_issue_n"))
        : [];

    // Build new rows with top 3 issues
        const enrichedRows = rows.map((row, index) => {
      // Get all issue/value pairs
      const issueEntries = issueKeys.map((key) => ({
        issue: issueData[key].label,
        value: row[key],
      }));

      // Sort by descending value
      issueEntries.sort((a, b) => b.value - a.value);

      const gov_performace = row["gov_good_n"]-row["gov_bad_n"]

      const nat_consider = row["nat_consider"]/10
      const lab_consider = row["lab_consider"]/10
      const act_consider = row["act_consider"]/10
      const nzf_consider = row["nzf_consider"]/10
      const tpm_consider = row["tpm_consider"]/10
      const green_consider = row["green_consider"]/10

      const nat_potential_voters = nat_consider-row["nat_pred_n"]
      const lab_potential_voters = lab_consider-row["lab_pred_n"]
      const act_potential_voters = act_consider-row["act_pred_n"]
      const nzf_potential_voters = nzf_consider-row["nzf_pred_n"]
      const tpm_potential_voters = tpm_consider-row["tpm_pred_n"]
      const green_potential_voters = green_consider-row["green_pred_n"]

      return {
        id: index,
        ...row,
        top_issue_1: issueEntries[0]
          ? `${issueEntries[0].issue} (${Math.round(issueEntries[0].value)}%)`
          : "",
        top_issue_1_value: issueEntries[0]?.value || 0,
        top_issue_1_name: issueEntries[0]?.issue || 0,
        top_issue_2: issueEntries[1]
          ? `${issueEntries[1].issue} (${Math.round(issueEntries[1].value)}%)`
          : "",
        top_issue_2_value: issueEntries[1]?.value || 0,
        top_issue_2_name: issueEntries[1]?.issue || 0,
        top_issue_3: issueEntries[2]
          ? `${issueEntries[2].issue} (${Math.round(issueEntries[2].value)}%)`
          : "",
        top_issue_3_value: issueEntries[2]?.value || 0,
        top_issue_3_name: issueEntries[2]?.issue || 0,
        gov_performace: gov_performace || "",
        nat_potential_voters: nat_potential_voters || "",
        lab_potential_voters: lab_potential_voters || "",
        act_potential_voters: act_potential_voters || "",
        nzf_potential_voters: nzf_potential_voters || "",
        tpm_potential_voters: tpm_potential_voters || "",
        green_potential_voters: green_potential_voters || "",
              nat_consider : nat_consider,
       lab_consider : lab_consider,
       act_consider : act_consider,
       nzf_consider : nzf_consider,
       tpm_consider : tpm_consider,
       green_consider : green_consider
      };
    });


    // ---- 1) Per-field colours (RGB) ----
// Define party full names and official colours
const PARTY_INFO = {
  nat_pred_n: { name: "National", color: "#0056A8" },
  act_pred_n: { name: "ACT", color: "#FFD700" },
  nzf_pred_n: { name: "NZF", color: "#000000" },
  lab_pred_n: { name: "Labour", color: "#E82C2C" },
  green_pred_n: { name: "Green", color: "#009639" },
  tpm_pred_n: { name: "TPM", color: "#CC0033" },
  oth_pred_n: { name: "Other", color: "#999999" },
  nat_consider: { name: "National", color: "#0056A8" },
  act_consider: { name: "ACT", color: "#FFD700" },
  nzf_consdier: { name: "NZF", color: "#000000" },
  lab_consider: { name: "Labour", color: "#E82C2C" },
  green_consider: { name: "Green", color: "#009639" },
  tpm_consider: { name: "TPM", color: "#CC0033" },
};

const ISSUE_INFO = {
  inflation_issue_n:   { name: "Inflation",    color: [169, 161, 158] },  // muted grey-brown
  health_issue_n:      { name: "Health",       color: [227, 119, 156] },  // soft pink-red
  econ_issue_n:        { name: "Economy",      color: [136, 204, 238] },  // light blue
  crime_issue_n:       { name: "Crime",        color: [148, 103, 189] },  // purple
  housing_issue_n:     { name: "Housing",      color: [196, 156, 148] },  // beige pink
  poverty_issue_n:     { name: "Poverty",      color: [214, 39, 40] },    // deep red
  unemployment_issue_n:{ name: "Unemployment", color: [181, 159, 59] },   // warm ochre
  climate_issue_n:     { name: "Climate",      color: [44, 160, 44] },    // green
  education_issue_issue_n: { name: "Education", color: [31, 119, 180] },  // blue
  transport_issue_n:   { name: "Transport",    color: [255, 127, 14] },   // orange
  drugs_issue_n:       { name: "Drugs",        color: [188, 189, 34] },   // olive green
  race_rel_issue_n:    { name: "Race relations", color: [23, 190, 207] }, // teal
  tax_issue_n:         { name: "Tax",          color: [255, 152, 150] },  // light red-pink
  pollution_issue_n:   { name: "Pollution",    color: [127, 127, 127] },  // grey
  maori_issue_n:       { name: "Māori Issues",        color: [140, 86, 75] },    // earthy brown
  immigration_issue_n: { name: "Immigration",  color: [188, 189, 34] },   // olive (reuse works fine)
  defence_issue_n:     { name: "Defence",      color: [31, 119, 180] },   // navy-blue
};

const hexToRgb = (hex) => {
  const bigint = parseInt(hex.replace("#", ""), 16);
  return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
};

// Build a map of field → [r,g,b] for gradient blending
const COLOURS = Object.fromEntries(
  Object.entries(PARTY_INFO).map(([key, { color }]) => [key, hexToRgb(color)])
);

// ---- 2) Min/max per numeric field ----
const numericKeys = enrichedRows.length > 0
        ? Object.keys(enrichedRows[0]).filter(
  (k) => typeof enrichedRows[0][k] === "number"
): [];

const minMax = numericKeys.reduce((acc, key) => {
  let min = Infinity, max = -Infinity;
  for (const r of enrichedRows) {
    const v = r[key];
    if (typeof v === "number" && !Number.isNaN(v)) {
      if (v < min) min = v;
      if (v > max) max = v;
    }
  }
  acc[key] = { min, max };
  return acc;
}, {});

// ---- 3) Utility: white → colour blend ----
const blendToColour = (value, { min, max }, [r, g, b]) => {
  if (value == null || Number.isNaN(value) || min === max) return "rgb(255,255,255)";
  const t = Math.max(0, Math.min(1, (value - min) / (max - min)));
  const rr = Math.round(255 + (r - 255) * t);
  const gg = Math.round(255 + (g - 255) * t);
  const bb = Math.round(255 + (b - 255) * t);
  return `rgb(${rr},${gg},${bb})`;
};


const blendPerformanceColour = (value, { min, max }) => {
  if (value == null || Number.isNaN(value)) return 'white';
  if (min === max) return 'white';

  // Symmetric scale
  const bound = Math.max(Math.abs(min), Math.abs(max));
  const ratio = Math.max(-1, Math.min(1, value / bound));

  let r, g, b;

  if (ratio < 0) {
    // Negative values: dark red → white
    const t = 1 + ratio; // -1..0 → 0..1
    r = Math.round(179 + (255 - 179) * t); // 179→255
    g = Math.round(0 + (255 - 0) * t);     // 0→255
    b = Math.round(0 + (255 - 0) * t);     // 0→255
  } else {
    // Positive values: white → dark green
    const t = ratio; // 0..1
    r = Math.round(255 - (255 - 0) * t);   // 255→0
    g = Math.round(255 - (255 - 153) * t); // 255→153
    b = Math.round(255 - (255 - 0) * t);   // 255→0
  }

  return `rgb(${r},${g},${b})`;
};


// Choose text colour (white on dark backgrounds, black otherwise)
const getTextColour = (value, { min, max }, rgb) => {
  if (value == null || Number.isNaN(value) || max === min) return "#000";
  const ratio = (value - min) / (max - min); // 0 = white, 1 = solid colour

  // Compute approximate brightness of the background colour
  const [r, g, b] = rgb;
  const blended = [
    Math.round(255 - (255 - r) * ratio),
    Math.round(255 - (255 - g) * ratio),
    Math.round(255 - (255 - b) * ratio),
  ];
  const brightness = (blended[0] * 299 + blended[1] * 587 + blended[2] * 114) / 1000;

  // If the blended background is dark (< 140), use white text
  return brightness < 180 ? "#fff" : "#000";
};



// ---- 4) Helper: build a % column with colouring ----
const makePercentColumn = (field, headerName, opts = {}) => ({
  field,
  headerName,
  flex: 1,
  minWidth: opts.minWidth ?? 130,
  sortable: true,
  sortComparator: nationalFirst(defaultCompare),   // 👈 add this line


  renderCell: (params) => {
    const value = params.value;
    const mm = minMax[field] ?? { min: 0, max: 1 };
    const rgb = COLOURS[field] ?? [200, 200, 200];
    const bg =
  field === 'gov_performace'
    ? blendPerformanceColour(value, mm)
    : blendToColour(value, mm, rgb);

      const textColour =
    field === "gov_performace"
      ? // special brightness test for gov_performace
        (() => {
          if (value == null || Number.isNaN(value)) return "#000";
          const bound = Math.max(Math.abs(mm.min), Math.abs(mm.max));
          const ratio = Math.abs(value / bound);
          // near extremes (|ratio| > .5) → white text
          return ratio > 0.5 ? "#fff" : "#000";
        })()
      : getTextColour(value, mm, rgb);


    return (
      <div style={{
        backgroundColor: bg,
        color: textColour,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',     // vertical centre
        justifyContent: 'center', // horizontal centre
        textAlign: 'center',
        pl: 1,       // left padding (theme spacing)
        m: 0,        // no margin
      }}>
        {value == null || Number.isNaN(value) ? "" : `${Number(value).toFixed(0)}%`}
      </div>
    );
  },
});
const removeDiacritics = (str) =>
  str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

const NATIONAL_LABEL = "National";

const defaultCompare = (a, b) => {
  if (a == null && b == null) return 0;
  if (a == null) return -1;
  if (b == null) return 1;
  if (typeof a === "number" && typeof b === "number") return a - b;
  return String(a).localeCompare(String(b), undefined, { numeric: true });
};

// Decorator: keep "National" row on top for ANY sort
const nationalFirst = (cmp) => (v1, v2, p1, p2) => {
  const sortDirection = p1.api.state.sorting.sortModel?.[0]?.sort || "asc";
  const aNat =
    p1.api.getCellValue(p1.id, "area_name") === NATIONAL_LABEL ||
    p1.id === NATIONAL_LABEL;
  const bNat =
    p2.api.getCellValue(p2.id, "area_name") === NATIONAL_LABEL ||
    p2.id === NATIONAL_LABEL;

  if (aNat && !bNat) return sortDirection === "asc" ? -1 : 1;
  if (!aNat && bNat) return sortDirection === "asc" ? 1 : -1;

  return cmp ? cmp(v1, v2, p1, p2) : defaultCompare(v1, v2);
};



    // ✅ Define exactly which columns you want to show
  const columns = [
    { field: "area_name", headerName: "Area", flex: 1, minWidth: 150, 
    sortComparator: nationalFirst(defaultCompare),
  renderCell: (params) => (

        <span>
      {params.value === "National" ? <b>Country wide</b> : params.value}
</span>
  ), },

  makePercentColumn("nat_pred_n", "National"),
  makePercentColumn("lab_pred_n", "Labour"),
  makePercentColumn("act_pred_n", "ACT"),
  makePercentColumn("green_pred_n", "Green"),
  makePercentColumn("nzf_pred_n", "NZF"),
  makePercentColumn("tpm_pred_n", "TPM"),
  makePercentColumn("turnout_1_p", "Turnout %", { minWidth: 120 }),
  makePercentColumn("gov_performace", "Government Performance", { minWidth: 150 }),

  // Top Issues (keep your numeric values for sorting, hide them if you like)
  // top issue cols (already have custom sort by *_value)
  {
  field: "top_issue_1",
  headerName: "Top Issue 1",
  flex: 1.3,
  minWidth: 180,
  sortable: true,
  sortComparator: nationalFirst((v1, v2, p1, p2) =>
    p1.api.getCellValue(p1.id, "top_issue_1_value") -
    p2.api.getCellValue(p2.id, "top_issue_1_value")
  ),
  renderCell: (params) => {
    const issueName = params.row.top_issue_1?.split(" (")[0] || ""; // extract name before %
    const issue = Object.entries(ISSUE_INFO).find(([key, obj]) =>
      obj.name.toLowerCase() === issueName.toLowerCase()
    );
    const colour = issue ? issue[1].color : [255, 255, 255];
    const bg = `rgb(${colour[0]}, ${colour[1]}, ${colour[2]})`;

    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: bg,
          color: "#fff",
          fontWeight: 600,
        }}
      >
        {params.value}
      </Box>
    );
  },
},
{
  field: "top_issue_2",
  headerName: "Top Issue 2",
  flex: 1.3,
  minWidth: 180,
  sortable: true,
  sortComparator: nationalFirst((v1, v2, p1, p2) =>
    p1.api.getCellValue(p1.id, "top_issue_2_value") -
    p2.api.getCellValue(p2.id, "top_issue_2_value")
  ),
  renderCell: (params) => {
    const issueName = params.row.top_issue_2?.split(" (")[0] || "";
    const normalisedName = removeDiacritics(issueName).toLowerCase();
    const issue = Object.entries(ISSUE_INFO).find(([key, obj]) =>
      removeDiacritics(obj.name).toLowerCase() === normalisedName ||
      (normalisedName === "maori" && obj.name.toLowerCase().includes("māori"))
    );
    const colour = issue ? issue[1].color : [255, 255, 255];
    const bg = `rgb(${colour[0]}, ${colour[1]}, ${colour[2]})`;

    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: bg,
          color: "#fff",
          fontWeight: 600,
        }}
      >
        {params.value}
      </Box>
    );
  },
},
{
  field: "top_issue_3",
  headerName: "Top Issue 3",
  flex: 1.3,
  minWidth: 180,
  sortable: true,
  sortComparator: nationalFirst((v1, v2, p1, p2) =>
    p1.api.getCellValue(p1.id, "top_issue_3_value") -
    p2.api.getCellValue(p2.id, "top_issue_3_value")
  ),
  renderCell: (params) => {
    const issueName = params.row.top_issue_3?.split(" (")[0] || "";
    const issue = Object.entries(ISSUE_INFO).find(([key, obj]) =>
      obj.name.toLowerCase() === issueName.toLowerCase()
    );
    const colour = issue ? issue[1].color : [255, 255, 255];
    const bg = `rgb(${colour[0]}, ${colour[1]}, ${colour[2]})`;

    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: bg,
          color: "#fff",
          fontWeight: 600,
        }}
      >
        {params.value}
      </Box>
    );
  },
},

  
  makePercentColumn("nat_consider", "National Consider"),
  makePercentColumn("nat_potential_voters", "National Soft Vote"),
  makePercentColumn("lab_consider", "Labour Consider"),
  makePercentColumn("lab_potential_voters", "Labour Soft Vote"),
  makePercentColumn("act_consider", "ACT Consider"),
  makePercentColumn("act_potential_voters", "ACT Soft Vote"),
  makePercentColumn("green_consider", "Green Consider"),
  makePercentColumn("green_potential_voters", "Green Soft Vote"),
  makePercentColumn("nzf_consider", "NZF Consider"),
  makePercentColumn("nzf_potential_voters", "NZF Soft Vote"),
  makePercentColumn("tpm_consider", "TPM Consider"),
  makePercentColumn("tpm_potential_voters", "TPM Soft Vote"),

];     
const rowsForGrid = [...enrichedRows].sort((a, b) => {
  const aNat = a.area_name === NATIONAL_LABEL;
  const bNat = b.area_name === NATIONAL_LABEL;
  return aNat === bNat ? 0 : aNat ? -1 : 1;
});




    return (

             <Box sx={{ height: "92vh", display: "flex", flexDirection: "column", width:'100%' }}>
        {/* HEADER (auto height, no flexGrow) */}
        <Box
          sx={(theme) => ({
            height:"25%",
            px: 3, py: 3,
            display: "flex", alignItems: "center",
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : theme.palette.background.default,
            borderBottom: `1px solid ${theme.palette.divider}`,
            // no flexGrow, no % height here
          })}
        >
          {/* left: icon + text */}
          <Stack direction="row" spacing={2} alignItems="center" sx={{ ml: 2,mb:2, mt:2 }}>
    
            <Box>
              <Typography variant="h5" fontWeight={700}>Electorate summary</Typography>
              <Typography variant="body1" color="text.secondary">
                <span>
                The table below summarises:
                <br/>- Predictions for the 2026 election by party
                 <br/>- Turnout prediction for the 2026 election
                 <br/>- Net Government Performance by electorate
                 <br/>- Top issues by electorate
                 <br/>- The share who would consider voting for each party
                 <br/>- Soft voters: Share of the population currently voting<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;for other parties that would consider voting for a party
                  </span>
              </Typography>
            </Box>
          <Stack direction="column" >
            <Typography variant="body1" color="text.secondary" sx={{mb:1}}>
                Use dropdowns below to filter by demographics (table will automatically update):
              </Typography>
              
          <Stack direction="row" spacing={2} alignItems="center" sx={{ ml: 4 }}>
                    <TextField
                        select
                        label="Gender"
                        size="small"
                        value={this.state.chosenGender}
                        onChange={(e) => this.handlechosenGenderChange?.(e.target.value)}
                        sx={{ minWidth: 180 }}
                        >
                        <MenuItem value={null}>All</MenuItem>
                        <MenuItem value="M">Male</MenuItem>
                        <MenuItem value="F">Female</MenuItem>
                        </TextField>

                        <TextField
                        select
                        label="Age"
                        size="small"
                        value={this.state.chosenAge}
                        onChange={(e) => this.handlechosenAgeChange?.(e.target.value)}
                        sx={{ minWidth: 180 }}
                        >
                        <MenuItem value={null}>All</MenuItem>
                        <MenuItem value="Young">Young</MenuItem>
                        <MenuItem value="Middle">Middle</MenuItem>
                        <MenuItem value="Old">Old</MenuItem>
                        </TextField>

                                        
                        <TextField
                        select
                        label="Education"
                        size="small"
                        value={this.state.chosenEducation}
                        onChange={(e) => this.handlechosenEducationChange?.(e.target.value)}
                        sx={{ mt: 3, minWidth: 180 }}
                        >
                        <MenuItem value={null}>All</MenuItem>
                        <MenuItem value="High">High</MenuItem>
                        <MenuItem value="Mid">Mid</MenuItem>
                        <MenuItem value="Low">Low</MenuItem>
                        </TextField>

                        <TextField
                        select
                        label="Ethnicity"
                        size="small"
                        value={this.state.chosenEthnicity}
                        onChange={(e) => this.handlechosenEthnicityChange?.(e.target.value)}
                        sx={{ minWidth: 180 }}
                        >
                        <MenuItem value={null}>All</MenuItem>
                        <MenuItem value="Asian only">Asian only</MenuItem>
                        <MenuItem value="European only">European only</MenuItem>
                        <MenuItem value="European/Māori">European/Māori</MenuItem>
                        <MenuItem value="Māori only">Māori only</MenuItem>
                        <MenuItem value="Pacific Peoples only">Other</MenuItem>
                        </TextField>

                        <TextField
                        select
                        label="2023 Vote"
                        size="small"
                        value={this.state.chosenPV}
                        onChange={(e) => this.handlechosenPVChange?.(e.target.value)}
                        sx={{ minWidth: 180 }}
                        >
                        <MenuItem value={null}>All</MenuItem>
                        <MenuItem value="ACT">ACT 2023</MenuItem>
                        <MenuItem value="GREEN">Green 2023</MenuItem>
                        <MenuItem value="LAB">Labour 2023</MenuItem>
                        <MenuItem value="NAT">National 2023</MenuItem>
                        <MenuItem value="NZF">NZF 2023</MenuItem>
                        <MenuItem value="TPM">TPM 2023</MenuItem>
                         <MenuItem value="OTH">Other 2023</MenuItem>
                        <MenuItem value="DNV">Did not vote</MenuItem>
                        </TextField>

          </Stack>
          </Stack>
          </Stack>
          
        </Box>

            
            
            <Box
                sx={{
                height: "75%",          // scrollable within viewport
                width: "100%",
                backgroundColor: "white",
                borderRadius: 0,
                mb:0.5,
                "& .MuiDataGrid-columnHeaders": { fontWeight: "bold" },
                "& .MuiDataGrid-cell": {
                    transition: "background-color 0.2s ease-in-out",
                    borderRight: "1px solid #f0f0f0",
                },
                }}
            >
                  {/* ---- Group heading bar ---- */}


                <DataGrid
                rows={rowsForGrid}
                columns={columns}
                disableRowSelectionOnClick
                hideFooter   
                sortingOrder={["desc", "asc"]}
                pagination={false}     // all rows available on scroll
                getRowId={(row) => row.id} // ensures unique key
                getRowClassName={(params) =>
                    params.row.area_name === "National" ? "national-row" : ""
                    }
                sx={{
                        "& .MuiDataGrid-virtualScroller": {
                            overflowY: "auto",
                        },

                        // === Base cell alignment ===
                        "& .MuiDataGrid-cell": {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            p: 0,
                            lineHeight: 1.2,
                            borderRight: "1px solid #ddd", // standard dividers
                        },

                        "& .MuiDataGrid-cell:last-of-type": {
                            borderRight: "none",
                        },

                        // === Header styles ===
                        "& .MuiDataGrid-columnHeaders": {
                            fontWeight: "bold",
                            backgroundColor: "#fafafa",
                            borderBottom: "2px solid #bbb",
                        },

                        "& .MuiDataGrid-columnHeader": {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRight: "1px solid #ddd",
                        },

                        "& .MuiDataGrid-columnHeader:last-of-type": {
                            borderRight: "none",
                        },

                        "& .MuiDataGrid-columnHeaderTitleContainer": {
                            flex: 1,
                            justifyContent: "center",
                        },

                        "& .MuiDataGrid-columnHeaderTitle": {
                              whiteSpace: "normal",      // ✅ allow wrapping
                                    lineHeight: 1.2,           // tighter vertical spacing
                                    overflow: "visible",       // prevent text clipping
                                    textAlign: "center",       // keep your centred alignment
                                    width: "100%",
                                    display: "block",          // ensures wrapping applies properly
                                    wordBreak: "break-word",   // handle very long words
                        },

                        // === ✅ Thick group dividers using [data-field] ===
                        '& .MuiDataGrid-cell[data-field="tpm_pred_n"]': {
                            borderRight: "2px solid #555",
                        },
                        '& .MuiDataGrid-cell[data-field="gov_performace"]': {
                            borderRight: "2px solid #555",
                        },
                        // '& .MuiDataGrid-cell[data-field="nat_pred_n"]': {
                        //     borderLeft: "2px solid #555",
                        // },
                        '& .MuiDataGrid-cell[data-field="turnout_1_p"]': {
                            borderRight: "2px solid #555",
                        },
                        '& .MuiDataGrid-cell[data-field="top_issue_3"]': {
                            borderRight: "2px solid #555",
                        },


                        // === National row style ===
                        "& .national-row": {
                            fontWeight: "bold",
                            backgroundColor: "rgba(0,0,0,0.05)",
                        },

                        // === Left-aligned exceptions ===
                        "& .left-align": {
                            justifyContent: "flex-start",
                            textAlign: "left",
                            pl: 1,
                        },
                        }}

                />
            </Box>
            </Box>
    );
  }
}


export default withRouter(NZ2026Summary);